import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import Cookies from "js-cookie";
import AddGovtOrder from "./AddGovtOrder";
import moment from "moment";
import UpdateGovtOrder from "./UpdateGovtOrder";
import Pagination from "../../Common/Pagination/Pagination";
import { toast } from "react-toastify";
import { sweetAlert } from "../../Common/Utills/Utills";
import _ from "lodash";
import { minDate } from "../../Constants/Constants";
import * as XLSX from "xlsx";

const GovtOrder = () => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rowData, setRowData] = useState([]);
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [company, setCompany] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [storeDiscom, setStoreDiscom] = useState([]);
  const [selectDiscomId, setSelectDiscomId] = useState("");

  const [filterCriteria, setfilterCriteria] = useState({
    company_id: selectedCompanyId ? selectedCompanyId : "",
    rca_date: "",
    status: "",
    rca_number: "",
    discom_id: "",
  });
  const [rowId, setRowId] = useState("");

  const exportToExcel = (rowData) => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Convert rowData to a worksheet
    const ws = XLSX.utils.json_to_sheet(
      rowData.map((item, index) => ({
        "S.NO": (currentPage - 1) * pageSize + index + 1,
        Region: item?.discomList?.discom_name,
        "Company Name":
          item.companyDetails.company_name +
          ", " +
          item?.companyDetails?.location,
        "Alloted Size": item?.alloted_details
          ?.map((detail) => detail.size)
          .join(", "),
        "Alloted Region": item?.alloted_details
          ?.map((detail) => detail.alloted_qty)
          .join(", "),
        "RCA.NO": item.rca_number,
        DATE: item.rca_date,
        "BG NUMBER": item.bg_number ? item.bg_number : "-",
        VALIDITY: item.validity ? item.validity : "-",
        DATE: item.rca_date,
        Status: item.status ? "Inactive" : "Active",
      }))
    );

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Govt Order Details");

    // Export the workbook
    XLSX.writeFile(wb, "Govt_Order_Details.xlsx");
  };

  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...filterCriteria,
        [name]: value,
      };
    });
  };
  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const formRef = useRef(null);
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setCurrentPage(1); // Reset to the first page when page size changes
  };
  const handleRefreshClick = () => {
    getData();
    setfilterCriteria({
      company_id: "",
      rca_date: "",
      status: "",
    });
    setSelectedCompanyId("");
    setSelectDiscomId("");
  };
  const nonEmptyFilterCriteria = Object.fromEntries(
    Object.entries(filterCriteria).filter(
      ([key, value]) => value !== null && value !== undefined && value !== ""
    )
  );
  const queryString = new URLSearchParams({
    company_id: selectedCompanyId || "",
    discom_id: selectDiscomId || "",
    skip: currentPage,
    take: pageSize,
    ...nonEmptyFilterCriteria,
  }).toString();

  const options = {
    whereFilters: nonEmptyFilterCriteria,
    skip: currentPage,
    take: pageSize,
  };
  const getData = async () => {
    let BASE_URL =
      SERVER_URL + `/api/govt-order/all-govt-order/${user_id}?${queryString}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(
        result?.data.map((item, index) => {
          return {
            ...item,
            rca_date: moment(item.rca_date).format("YYYY-MM-DD"),
          };
        })
      );
    } else {
      setRowData([]);
    }
  };

  let check = true;
  useEffect(() => {
    if (check) {
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
    check = false;
  }, [currentPage, pageSize, filterCriteria]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);

  const addDataToModal = (id) => {
    setRowId(id);
  };
  const deleteOrderData = async (order_id) => {
    const message = "Do you want to delete this govt order details!";
    const result = await sweetAlert(message);
    if (!result.isConfirmed) {
      return;
    }
    let BASE_URL =
      SERVER_URL + `/api/govt-order/govt-order/${user_id}/${order_id}`;
    const res = await fetch(BASE_URL, {
      method: "DELETE",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const response = await res.json();
    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
    }
  };
  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);

  const handleCompanyChange = (e) => {
    const companyId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectedCompanyId(companyId);

    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
    }));
  };
  const handleDiscomChange = (e) => {
    const discomId = e.target.value != "" ? parseInt(e.target.value) : "";
    setSelectDiscomId(discomId);

    // Update filterCriteria with the selected company's ID
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      discom_id: discomId,
    }));
  };

  const getDiscomData = async () => {
    const BASE_URL = `${SERVER_URL}/api/discom/all-discoms/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStoreDiscom(result.data);
    } else {
      setStoreDiscom([]);
    }
  };

  useEffect(() => {
    getDiscomData();
  }, []);
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Govt Order Details &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div
              className="mb-3"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <button
                data-toggle="modal"
                data-target="#exampleModal"
                className="btn btn-outline-primary"
              >
                <span className="mr-1">
                  <i className="mdi mdi-briefcase-upload" />
                </span>
                Add RCA
              </button>
              <button
                className="btn btn-outline-excel  ml-2"
                onClick={() => exportToExcel(rowData)}
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-excel" />
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div className="search mb-3">
            <div className="row">
              <div className="col-md-2">
                <div className="form-group">
                  <select
                    className="form-control form-control-lg"
                    onChange={handleCompanyChange}
                    value={selectedCompanyId}
                  >
                    <option value="">Select Company (All)</option>
                    {company?.map((item, id) => {
                      return (
                        <React.Fragment key={id}>
                          <option
                            value={item.id}
                            key={id}
                          >{`${item.company_name}, ${item.location}`}</option>
                        </React.Fragment>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <select
                    className="form-control form-control-lg"
                    onChange={handleDiscomChange}
                    value={selectDiscomId}
                  >
                    <option value="">Select Discom (All)</option>
                    {storeDiscom?.map((item, id) => {
                      return (
                        <React.Fragment key={id}>
                          <option
                            value={item.id}
                            key={id}
                          >{`${item.discom_name}`}</option>
                        </React.Fragment>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <input
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Search by RCA"
                  onChange={(e) =>
                    handleFilterChange("rca_number", e.target.value)
                  }
                  value={filterCriteria.rca_number}
                />
              </div>
              <div className="col-md-2">
                <input
                  type="date"
                  className="form-control form-control-lg"
                  placeholder="Search by Date"
                  max={new Date().toISOString().split("T")[0]}
                  onChange={(e) =>
                    handleFilterChange("rca_date", e.target.value)
                  }
                  value={filterCriteria.rca_date}
                  min={minDate}
                />
              </div>
              <div className="col-md-2">
                <select
                  className="form-control form-control-lg"
                  onChange={(e) =>
                    handleFilterChange(
                      "status",
                      e.target.value === "" ? "" : e.target.value === "true"
                    )
                  }
                  value={filterCriteria.status}
                >
                  <option value="">Select Status (All)</option>
                  <option value="false">Active</option>
                  <option value="true">Inactive</option>
                </select>
              </div>
            </div>
          </div>
          <div className="private-table-container">
            <div
              className="table-responsive table-bordered govt-table"
              style={{ border: "0.05px solid lightGray", width: "auto" }}
            >
              <table className="table" style={{ margin: 0 }}>
                <thead>
                  <tr>
                    <th rowSpan="2">S.NO</th>
                    <th rowSpan="2">Region</th>
                    <th rowSpan="2">Company Name</th>
                    <th
                      colSpan="2"
                      style={{
                        textAlign: "center",
                        verticalAlign: "top",
                      }}
                    >
                      Alloted
                    </th>
                    <th rowSpan="2">RCA.NO</th>
                    <th rowSpan="2">DATE</th>
                    <th rowSpan="2">BG Number</th>
                    <th rowSpan="2">Validity</th>
                    <th rowSpan="2">Status</th>
                    <th rowSpan="2">Action</th>
                  </tr>
                  <tr>
                    <th>Size</th>
                    <th>Alloted Region</th>
                  </tr>
                </thead>
                <tbody>
                  {rowData && rowData.length > 0 ? (
                    rowData.map((item, index) => (
                      <tr key={index}>
                        {/* <td>{index + 1}</td> */}
                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                        <td>{item?.discomList?.discom_name}</td>
                        <td>
                          {item.companyDetails.company_name +
                            ", " +
                            item?.companyDetails?.location}
                        </td>
                        <td
                          style={{
                            lineHeight: "30px",
                            verticalAlign: "top",
                            textAlign: "center",
                            // padding: "10px 0",
                          }}
                        >
                          {item?.alloted_details?.map((detail, idx) => (
                            <div key={idx}>
                              <div>{detail.size}</div>
                            </div>
                          ))}
                        </td>
                        <td
                          style={{
                            lineHeight: "30px",
                            verticalAlign: "top",
                            textAlign: "center",
                            // padding: "10px 0",
                          }}
                        >
                          {item?.alloted_details?.map((detail, idx) => (
                            <div key={idx}>
                              <div>{detail.alloted_qty}</div>
                            </div>
                          ))}
                        </td>
                        <td>{item.rca_number}</td>
                        <td>{item.rca_date}</td>
                        <td>{item.bg_number ? item.bg_number : "-"}</td>
                        <td>{item.validity ? item.validity : "-"}</td>
                        <td>
                          <span
                            style={{
                              padding: item.status ? "10px 12px" : "10px 16px",
                            }}
                            className={`badge ${
                              item.status ? "badge-secondary" : "badge-success"
                            }`}
                          >
                            {item.status ? "Inactive" : "Active"}
                          </span>
                        </td>
                        <td style={{ padding: "10px" }}>
                          <button
                            className="btn btn-outline-secondary btn-sm ml-2"
                            onClick={() => addDataToModal(item.id)}
                            data-toggle="modal"
                            data-target="#updateModal"
                          >
                            <i className="mdi mdi-note-edit-outline" />
                          </button>
                          <button
                            className="btn btn-outline-danger btn-sm ml-2"
                            onClick={() => deleteOrderData(item.id)}
                          >
                            <i className="mdi mdi-delete" />
                          </button>
                          <NavLink
                            className="btn btn-outline-info btn-sm ml-1"
                            to={"/view-govt-order/" + item.id}
                          >
                            <i className="mdi mdi-eye-arrow-right-outline" />
                          </NavLink>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">
                        <div className="loading-container">
                          <p>No row to show</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <AddGovtOrder getData={getData} formRef={formRef} />
            <UpdateGovtOrder
              rowId={rowId}
              setRowId={setRowId}
              getData={getData}
            />
          </div>
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default GovtOrder;
